import Main from '@/views/Main'
import NewsType from '@/views/news/NewsType'
import News from '@/views/news/News'
import NewsEdit from '@/views/news/NewsEdit'
import Login from '@/views/login/Login'
import User from '@/views/user/User'
import PayType from '@/views/pay/PayType'
import PayItem from '@/views/pay/PayItem'
import OrderList from '@/views/order/OrderList'
import MpMenu from '@/views/menu/MpMenu'
import Role from '@/views/role/Role'
import OrderTotalList from '@/views/order/OrderTotalList'
import Image from '@/views/image/Index'


export default [{
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Main',
    name: 'Main',
    component: Main,
    children: [{
      path: 'news/type',
      name: 'NewsType',
      component: NewsType,
    }, {
      path: 'news',
      name: 'News',
      component: News
    }, {
      path: 'news/edit',
      name: 'NewsEdit',
      component: NewsEdit
    }, {
      path: 'user',
      name: 'User',
      component: User
    },{
      path: 'payType',
      name: 'PayType',
      component: PayType
    },{
      path: 'payItem',
      name: PayItem,
      component: PayItem
    },{
      path: 'order',
      name: 'OrderList',
      component: OrderList
    },{
      path: 'mp-menu',
      name: 'MpMenu',
      component: MpMenu
    },{
      path: "role",
      name: 'Role',
      component: Role
    },{
      path: 'order-total',
      name: 'OrderTotalList',
      component: OrderTotalList
    },{
      path:"image",
      name: 'Image',
      component: Image
    }]
  }
]



// WEBPACK FOOTER //
// ./src/router/admin.js